import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SrEquipmentService {
    constructor(private readonly datatask: DataTaskService) {}

    /** @datatask 1794 */
    public async getEquipment(params: SrEquipmentParams): Promise<SrEquipmentGet> { return (await this.datatask.Post(1794, params))[0]; }
    /** @datatask 1796 */
    public async saveEquipment(page: SrEquipmentGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1796, page))[0]; }
    /** @datatask 1795 */
    public getRefundTypes(params: { resource_id: string } | { add_all: '1' }): Promise<SrEquipmentRefundType[]> { return this.datatask.Post(1795, params); }
    /** @datatask 1797 */
    public getFuelTypes(): Promise<SrEquipmentFuelType[]> { return this.datatask.Post(1797, {}); }
    /** @datatask 1801 */
    public getDroneTypes(): Promise<SrEquipmentDroneType[]> { return this.datatask.Post(1801, {}); }
    /** @datatask 1792 */
    public async getEquipments(params: { resource_id: string }): Promise<SrEquipmentsGet> { return (await this.datatask.Post(1792, params))[0]; }
    /** @datatask 1793 */
    public getEquipmentList(params: { resource_id: string }): Promise<Item[]> { return this.datatask.Post(1793, params); }
    /** @datatask 1821 */
    public async getResourceView(): Promise<SrEquipmentResourceViewGet> { return (await this.datatask.Post(1821, {}))[0]; }
    /** @datatask 1825 */
    public getResourceViews(params: { sub_resource_id: string; srrefundtype_id: string }): Promise<Item[]> { return this.datatask.Post(1825, params); }
}

export interface SrEquipmentParams { resource_id: string; srequipment_keyno: string; }
export interface SrEquipmentGet extends SrEquipmentParams {
    description: string;
    srrefundtype_id: string;
    fueltype_id: string;
    smallboat_rate: string | number;
    dronetype_id: string;
    drone_base_rate: string | number;
    drone_rate: string | number;
    srequipment_regno: string;
    isactive: '0' | '1';
    reg_datetime: string;
    reg_by_portal_user_name: string;
    frr_id: string;
}
export interface SrEquipmentRefundType { srrefundtype_id: string; srrefundtype_name: string; }
export interface SrEquipmentFuelType { fueltype_id: string; fueltype_name: string; }
export interface SrEquipmentDroneType { dronetype_id: string; dronetype_name: string; }
export interface SrEquipmentsGet { resource_id: string; resource_name: string; searchtext: string; }
export interface SrEquipmentResourceViewGet { main_resource_id: string; sub_resource_id: string; srrefundtype_id: string; }
